import type { AssignmentItem, AssignmentSession } from './useAssignmentSession';

function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return '';
  const s = String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function buildCsv(items: AssignmentItem[]): string {
  const header = ['orderUuid', 'result', 'reason', 'orderState', 'partnerName'];
  const rows = items.map((it) =>
    [it.orderUuid, it.result, it.reason ?? '', it.orderState ?? '', it.partnerName ?? '']
      .map(escapeCell)
      .join(','),
  );
  return [header.join(','), ...rows].join('\n');
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function exportSession(
  session: AssignmentSession,
  bucket?: 'processed' | 'conflict' | 'failed',
) {
  const items = bucket ? session.items.filter((it) => it.result === bucket) : session.items;
  const suffix = bucket ? `-${bucket}` : '-all';
  downloadCsv(`assignment-${session.sessionId}${suffix}.csv`, buildCsv(items));
}
